import { EPlantStatus } from "../enums/plant-status";
import { IShallowSolarPlantView } from "../interfaces/shallow-solar-plant-view";
import { MtIcon } from "../ui-elements/material-icon/material-icon";

export const getSiteStatusInfo = (
  solarPlant: IShallowSolarPlantView,
): { label: string; color: string; bgColor: string; icon: MtIcon } => {
  switch (solarPlant.status) {
    case EPlantStatus.FAULT:
      return {
        label: "Fault",
        color: "#bf4545", // danger
        bgColor: "#faecec", // icon-6
        icon: "error",
      };
    case EPlantStatus.OFFLINE:
      return {
        label: "Offline",
        color: "#6f757e", // gray
        bgColor: "#f3f3f3", // gray-11
        icon: "wifi_off",
      };
    case EPlantStatus.GENERATING:
      return {
        label: "Generating",
        color: "#0ea11c", // green-5
        bgColor: "#ecfaed", // icon-4
        icon: "bolt",
      };
    case EPlantStatus.ACTIVE:
      return {
        label: "Active",
        color: "#0ea11c", // green-5
        bgColor: "#ecfaed", // icon-4
        icon: "check_circle",
      };
    // Online and powered but not producing - at night the inverter draws a few watts to keep its
    // electronics running. A normal state, not a warning, so it shares the healthy green.
    case EPlantStatus.WAITING:
      return {
        label: "Standby",
        color: "#0ea11c", // green-5
        bgColor: "#ecfaed", // icon-4
        icon: "power_settings_new",
      };
    case EPlantStatus.DISABLED:
      return {
        label: "Disabled",
        color: "#6f757e", // gray
        bgColor: "#f3f3f3", // gray-11
        icon: "block",
      };
    case EPlantStatus.UNKNOWN:
    default:
      return {
        label: "Unknown",
        color: "#6f757e", // gray
        bgColor: "#f3f3f3", // gray-11
        icon: "help",
      };
  }
};
